import LocalSettingsProto from "../../core/gd/settings/local-settings/local-settings-v4";
import {ProjectsTreeSortType} from "../../core/model2/space/@types";

// export default class MenuLocalSettings extends LocalSettingsProtoDepricated {
export default class NavigationMenu_ProjectsLocalSettings extends LocalSettingsProto {

    private _sortType                 : ProjectsTreeSortType = ProjectsTreeSortType.ALPHABETICAL
    private _expandedProjects         : ID[] = []
    private _expandedPinnedProjects   : ID[] = []
    private _collapsedDepartments     : ID[] = []

    constructor(id: ID = 'projects') {
        super('menu-{0}-{1}'.f(gd.companyId, id))

        const values = this._readFromLocalStorage()

        this._sortType               = _.get(values, 'sortType', ProjectsTreeSortType.ALPHABETICAL)
        this._expandedProjects       = _.get(values, 'expandedProjects', [])
        this._expandedPinnedProjects = _.get(values, 'expandedPinnedProjects', [])
        this._collapsedDepartments   = _.get(values, 'collapsedDepartments', [])
    }

    get sortType() {
        return this._sortType
    }

    set sortType(value:ProjectsTreeSortType) {
        this._sortType = value
        this.save()
    }

    get expandedProjects() {
        return this._expandedProjects
    }

    set expandedProjects(value:ID[]) {
        this._expandedProjects = value
        this.save()
    }

    get expandedPinnedProjects() {
        return this._expandedPinnedProjects
    }

    set expandedPinnedProjects(value:ID[]) {
        this._expandedPinnedProjects = value
        this.save()
    }

    get collapsedDepartments() {
        return this._collapsedDepartments
    }

    set collapsedDepartments(value:ID[]) {
        this._collapsedDepartments = value
        this.save()
    }



    toObject() {
        return {
            sortType                : this._sortType,
            expandedProjects        : this._expandedProjects,
            expandedPinnedProjects  : this._expandedPinnedProjects,
            collapsedDepartments    : this._collapsedDepartments,
        }
    }
}




//
//
//
// import LocalSettingsProtoDepricated from "../../core/gd/settings/local-settings/local-settings-v3"
// import {ProjectsTreeSortType} from "./sections/projects/sorting/button"
// import LocalSettingsProto from "../../core/gd/settings/local-settings/local-settings-v4";
//
// export default class MenuLocalSettings extends LocalSettingsProtoDepricated {
//
//     public sortType                 : ProjectsTreeSortType = ProjectsTreeSortType.ALPHABETICAL
//     public expandedProjects         : ID[] = []
//     public expandedPinnedProjects   : ID[] = []
//     public collapsedDepartments     : ID[] = []
//
//     constructor() {
//         super('menu-'+gd.companyId, {})
//
//         // call duplicate required because of type script
//         this.normalize(this._readFromLocalStorage())
//     }
//
//     normalize(values:any) {
//         this.sortType               = _.get(values, 'sortType', ProjectsTreeSortType.ALPHABETICAL)
//         this.expandedProjects       = _.get(values, 'expandedProjects', [])
//         this.expandedPinnedProjects = _.get(values, 'expandedPinnedProjects', [])
//         this.collapsedDepartments   = _.get(values, 'collapsedDepartments', [])
//     }
//
//     toObject() {
//         return {
//             sortType                : this.sortType,
//             expandedProjects        : this.expandedProjects,
//             expandedPinnedProjects  : this.expandedPinnedProjects,
//             collapsedDepartments    : this.collapsedDepartments,
//         }
//     }
// }
//
